// Formats a widget value according to the backend's format hint. Numbers use
// German locale; currency hints render Euro amounts (cents or whole euros).
export function formatWidgetValue(value, format) {
  const num = Number(value) || 0;
  switch (format) {
    case 'currencyCents':
      return (num / 100).toLocaleString('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    case 'currencyEuros':
      return num.toLocaleString('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    case 'int':
    default:
      return num.toLocaleString('de-DE');
  }
}
